class n extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector("details");
    this.detailsChildren = this.querySelectorAll(
      "details .list-menu:not([data-mega-menu]) details"
    );
    this.summary = this.querySelector("summary");
    this.nav = this.closest("nav");

    this.details.addEventListener("click", (e) => this.onOpenPanel(e));
    this.addEventListener("keyup", (e) => this.panelKeyUp(e));

    if (this.details.classList.contains("header-menu__details")) {
      this.addEventListener("focusout", (e) => this.panelFocusCheck(e));
      this.addEventListener("pointerenter", (e) => this.panelPointerEnter(e));
      this.addEventListener("pointerleave", (e) => this.panelPointerLeave(e));
    }
  }

  onOpenPanel(e) {
    console.log("onOpenPanel Triggered: Event Type:", e.type);
    const t = e.target.closest("details");
    this.detailsChildren.forEach((i) => {
      if (i !== t) this.hidePanel(i);
    });
    this.nav &&
      this.nav
        .querySelectorAll("details.drawer-menu__details, details.menu__details")
        .forEach((s) => {
          if (s !== t) this.hidePanel(s);
        });

    if (
      e.type === "click" &&
      e.detail > 0 &&
      window.theme.isMouseDevice &&
      t.classList.contains("header-menu__details")
    ) {
      console.log("Redirect triggered for link:", t.dataset.link);
      window.location.href = t.dataset.link;
    }
  }

  panelPointerEnter(e) {
    console.log("Pointer Enter:", e.target, "Related Target:", e.relatedTarget);
    this.openPanel(this.details);
  }

  panelPointerLeave(e) {
    console.log(
      "Pointer Leave:",
      e.target,
      "Related Target:",
      e.relatedTarget
    );

    // Check if leaving the entire details element
    if (!this.contains(e.relatedTarget)) {
      console.log("Hiding panel as mouse completely left");
      this.hidePanel(this.details);
    } else {
      console.log("Mouse moved to a child element, panel remains open");
    }
  }

  panelFocusCheck(e) {
    console.log("Focus Check Triggered", "Related Target:", e.relatedTarget);
    if (!this.contains(e.relatedTarget)) {
      this.hidePanel(this.details);
    }
  }

  panelKeyUp(e) {
    console.log("Key Up:", e.code);
    if (e.code.toUpperCase() !== "ESCAPE") return;
    const t = document.activeElement.closest("details"),
      i = t.querySelector("summary");
    this.hidePanel(t);
    i.focus();
  }

  openPanel(e) {
    console.log("Opening panel:", e);
    e.setAttribute("open", true);
  }

  hidePanel(e) {
    console.log("Hiding panel:", e);
    e.removeAttribute("open");
  }
}

customElements.define("disclosure-menu", n);
